import * as L from 'leaflet';
import 'leaflet-editable';
import { isFlat } from 'leaflet/src/geometry/LineUtil';
import { cloneDeep } from 'lodash/lang';

export const HorusPolygonEditor = window.L.Editable.PolygonEditor.extend({
	RADIUS: 20,
	VERTEX_DRAGGING: false,
	featureBackup: null,

	addHooks: function() {
		window.L.Editable.BaseEditor.prototype.addHooks.call(this);
		if (this.feature) {
			this.map['editingFeature'] = this.feature;
			this.map.on(
				'editable:dragstart',
				this.onEditingFeatureVertexDragStart,
			);
			this.map.on('editable:dragend', this.onEditingFeatureVertexDragEnd);
			this.map.on(
				'editable:vertex:dragstart',
				this.onEditingFeatureVertexDragStart,
			);
			this.map.on(
				'editable:vertex:dragend',
				this.onEditingFeatureVertexDragEnd,
			);
			this.map.on('mousemove', this.onMouseMove);
		}
		return this;
	},

	removeHooks: function() {
		this.feature.off(this._getEvents(), this);
		if (this.feature.dragging) this.feature.dragging.disable();
		this.editLayer.clearLayers();
		this.tools.editLayer.removeLayer(this.editLayer);
		this.onDisable();
		if (this._drawing) this.cancelDrawing();
		this.map.off('editable:vertex:dragstart');
		this.map.off('editable:vertex:dragend');
		this.map.off('mousemove');
	},

	loadVertexMarkers: function(latlngs, centerPoint) {
		if (!this.enabled()) return;
		if (!centerPoint) return;
		latlngs = latlngs || this.getLatLngs();
		if (isFlat(latlngs)) {
			for (let i = 0; i < latlngs.length; i++) {
				const isInsideRadius =
					Math.abs(centerPoint.distanceTo(latlngs[i])) <= this.RADIUS;
				if (isInsideRadius) {
					if (!latlngs[i].__vertex) {
						let previous = null;
						if (i === 0)
							previous = new HorusVertexMarker(
								latlngs[latlngs.length - 1],
								latlngs,
								this,
								{},
								true,
							);
						else
							previous = new HorusVertexMarker(
								latlngs[i - 1],
								latlngs,
								this,
								{},
								true,
							);

						const vertex = this.addVertexMarker(
							latlngs[i],
							latlngs,
						);
						if (!vertex.middleMarker)
							vertex.addMiddleMarker(previous);
					} else {
						this.editLayer.addLayer(latlngs[i].__vertex);
					}
				} else if (latlngs[i].__vertex) {
					this.editLayer.removeLayer(latlngs[i].__vertex);
				}
			}
		} else
			for (let i = 0; i < latlngs.length; i++)
				this.loadVertexMarkers(latlngs[i], centerPoint);
	},

	onMouseMove: function(e) {
		if (!this.editingFeature.editor.VERTEX_DRAGGING) {
			const centerPoint = e.latlng;
			this.editingFeature.editor.loadVertexMarkers(null, centerPoint);
		} else {
			if (this.editingFeature.intersects()) {
				this.editingFeature.setStyle({
					fillColor: '#b00b00',
					color: '#b00b00',
				});
			} else {
				this.editingFeature.setViewStyle();
			}
		}
	},

	onEditingFeatureVertexDragStart() {
		this.featureBackup = cloneDeep(this.editingFeature);
		this.editingFeature.editor.VERTEX_DRAGGING = true;
	},

	onEditingFeatureVertexDragEnd() {
		if (this.editingFeature.intersects()) {
			this.editingFeature.setLatLngs(this.featureBackup.getLatLngs());
			this.editingFeature.editor.reset();
		}
		this.editingFeature.editor.VERTEX_DRAGGING = false;
	},

	onDragStart: function(e) {
		this.editLayer.clearLayers();
		this.updateVertexes();
		window.L.Editable.BaseEditor.prototype.onDragStart.call(this, e);
	},

	onDragEnd: function(e) {
		this.editLayer.clearLayers();
		this.updateVertexes();
		window.L.Editable.BaseEditor.prototype.onDragEnd.call(this, e);
	},

	updateVertexes: function(latlngs) {
		latlngs = latlngs || this.getLatLngs();
		if (isFlat(latlngs)) {
			for (let i = 0; i < latlngs.length; i++) {
				if (latlngs[i].__vertex) {
					if (latlngs[i].__vertex.middleMarker)
						latlngs[i].__vertex.middleMarker.updateLatLng();
					latlngs[i].__vertex.update();
				}
			}
		} else
			for (let i = 0; i < latlngs.length; i++)
				this.updateVertexes(latlngs[i]);
	},
});

export const HorusPolylineEditor = window.L.Editable.PolylineEditor.extend({
	RADIUS: 20,
	VERTEX_DRAGGING: false,
	addHooks: function() {
		window.L.Editable.BaseEditor.prototype.addHooks.call(this);
		if (this.feature) {
			this.map['editingFeature'] = this.feature;
			this.map.on(
				'editable:vertex:dragstart',
				this.onEditingFeatureVertexDragStart,
			);
			this.map.on(
				'editable:vertex:dragend',
				this.onEditingFeatureVertexDragEnd,
			);
			this.map.on('mousemove', this.onMouseMove);
		}
		return this;
	},

	removeHooks: function() {
		this.feature.off(this._getEvents(), this);
		if (this.feature.dragging) this.feature.dragging.disable();
		this.editLayer.clearLayers();
		this.tools.editLayer.removeLayer(this.editLayer);
		this.onDisable();
		if (this._drawing) this.cancelDrawing();
		this.map.off('editable:vertex:dragstart');
		this.map.off('editable:vertex:dragend');
		this.map.off('mousemove');
	},

	loadVertexMarkers: function(latlngs, centerPoint) {
		if (!this.enabled()) return;
		if (!centerPoint) return;
		latlngs = latlngs || this.getLatLngs();
		if (isFlat(latlngs)) {
			for (let i = 0; i < latlngs.length; i++) {
				const isInsideRadius =
					Math.abs(centerPoint.distanceTo(latlngs[i])) <= this.RADIUS;
				if (isInsideRadius) {
					if (!latlngs[i].__vertex) {
						let previous = null;
						if (i === 0)
							previous = new HorusVertexMarker(
								latlngs[latlngs.length - 1],
								latlngs,
								this,
								{},
								true,
							);
						else
							previous = new HorusVertexMarker(
								latlngs[i - 1],
								latlngs,
								this,
								{},
								true,
							);

						const vertex = this.addVertexMarker(
							latlngs[i],
							latlngs,
						);
						if (!vertex.middleMarker)
							vertex.addMiddleMarker(previous);
					} else {
						this.editLayer.addLayer(latlngs[i].__vertex);
					}
				} else if (latlngs[i].__vertex) {
					this.editLayer.removeLayer(latlngs[i].__vertex);
				}
			}
		} else
			for (let i = 0; i < latlngs.length; i++)
				this.loadVertexMarkers(latlngs[i], centerPoint);
	},

	onMouseMove: function(e) {
		if (!this.editingFeature.editor.VERTEX_DRAGGING) {
			const centerPoint = e.latlng;
			this.editingFeature.editor.loadVertexMarkers(null, centerPoint);
		}
	},

	onEditingFeatureVertexDragStart() {
		this.editingFeature.editor.VERTEX_DRAGGING = true;
	},

	onEditingFeatureVertexDragEnd() {
		this.editingFeature.editor.VERTEX_DRAGGING = false;
	},

	onDragStart: function(e) {
		this.editLayer.clearLayers();
		this.updateVertexes();
		window.L.Editable.BaseEditor.prototype.onDragStart.call(this, e);
	},

	onDragEnd: function(e) {
		this.initVertexMarkers();
		this.updateVertexes();
		window.L.Editable.BaseEditor.prototype.onDragEnd.call(this, e);
	},

	updateVertexes: function(latlngs) {
		latlngs = latlngs || this.getLatLngs();
		if (isFlat(latlngs)) {
			for (let i = 0; i < latlngs.length; i++) {
				if (latlngs[i].__vertex) {
					if (latlngs[i].__vertex.middleMarker)
						latlngs[i].__vertex.middleMarker.updateLatLng();
					latlngs[i].__vertex.update();
				}
			}
		} else
			for (let i = 0; i < latlngs.length; i++)
				this.updateVertexes(latlngs[i]);
	},
});

export const HorusVertexMarker = window.L.Editable.VertexMarker.extend({
	initialize: function(latlng, latlngs, editor, options, tmp = false) {
		// We don't use this._latlng, because on drag Leaflet replace it while
		// we want to keep reference.
		this.latlng = latlng;
		this.latlngs = latlngs;
		this.editor = editor;
		L.Marker.prototype.initialize.call(this, latlng, options);
		this.options.icon = this.editor.tools.createVertexIcon({
			className: this.options.className,
		});
		if (!tmp) {
			this.latlng.__vertex = this;
			this.editor.editLayer.addLayer(this);
		}
		this.setZIndexOffset(editor.tools._lastZIndex + 1);
	},

	onDrag: function(e) {
		e.vertex = this;
		this.editor.onVertexMarkerDrag(e);
		let iconPos = L.DomUtil.getPosition(this._icon),
			latlng = this._map.layerPointToLatLng(iconPos);
		this.latlng.update(latlng);
		this._latlng = this.latlng; // Push back to Leaflet our reference.
		this.editor.refresh();
		if (this.middleMarker) this.middleMarker.updateLatLng();
		let next = this.getNext();
		if (next && next.middleMarker) next.middleMarker.updateLatLng();
		this.editor.updateVertexes();
	},

	onRemove: function(map) {
		// if (this.middleMarker) this.middleMarker.delete()
		// delete this.latlng.__vertex
		this.off('drag', this.onDrag);
		this.off('dragstart', this.onDragStart);
		this.off('dragend', this.onDragEnd);
		this.off('mouseup', this.onMouseup);
		this.off('click', this.onClick);
		this.off('contextmenu', this.onContextMenu);
		this.off('mousedown touchstart', this.onMouseDown);
		this.off('mouseover', this.onMouseOver);
		this.off('mouseout', this.onMouseOut);
		L.Marker.prototype.onRemove.call(this, map);
	},
});
